/**
 * @module views\mdl\material\material
 */
import Vue from "vue";
import Component from "vue-class-component";

import { TreeNode } from "element-ui/types/tree";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import { Watch, Mixins } from "vue-property-decorator";
import MaterialService from "./service";
import GhBase from "@/components/ghBase";

@Component
export default class Material extends Mixins(GhBase, MaterialService) {
  private tabs: IGhTab[] = [
    {
      show: true,
      drawer: true,
      title: "物料维护"
    },
    {
      drawer: false,
      title: "物料明细"
    }
  ];

  private argsQeury = { type_cd: "", keyword: "" };

  private selectedNode: TreeNode<string, IndexObject> | any = {};
  private beforeSave(item: IndexObject) {
    if (this.selectedNode.key) {
      item.TypeCd = this.selectedNode.data.Cd;
      item.TypeName = this.selectedNode.data.Name;
    }
  }

  @Watch("selectedNode")
  private resetArgs() {
    if (
      this.selectedNode &&
      this.selectedNode.data &&
      this.selectedNode.data.Cd
    ) {
      this.argsQeury.type_cd = this.selectedNode.data.Cd;
    }
  }

  @Watch("argsQeury.type_cd")
  private async query() {
    if (this.table) {
      await this.table.query(this.argsQeury);
      this.argsQeury.keyword = "";
    }
  }

  private get table() {
    return this.$refs.table as GhTablePage;
  }
}
